import Component from 'D:/AUTOMFL/UniApp/uniAdmin/windows/leftWindow.vue'
wx.createComponent(Component)